import { Stack } from '@chakra-ui/react';
import * as React from 'react';

import { AttributeFragment } from '../../graphql-types/AttributeFragment';
import { PreviewAttribute } from './components/PreviewAttribute';

export const Preview: React.FC<{
  attributes: AttributeFragment[];
  onClickAddValue?: (attributeId: string) => void;
  isViewingOwnProfile: boolean;
}> = ({ attributes, onClickAddValue, isViewingOwnProfile }) => {
  return (
    <Stack spacing="6">
      {attributes.map((attribute) => (
        <PreviewAttribute
          key={attribute._id}
          attribute={attribute}
          onClickAddValue={onClickAddValue}
          isViewingOwnProfile={isViewingOwnProfile}
        />
      ))}
    </Stack>
  );
};
